// Material Dashboard 2 React base styles
import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';

// Material Dashboard 2 React helper functions
import pxToRem from 'assets/theme/functions/pxToRem';

const { light, gradients, white, info } = colors;

const { fontWeightRegular, size: fontSize } = typography;

const paginationItem = {
  styleOverrides: {
    root: {
      margin: `0 ${pxToRem(2)}`,
      fontWeight: fontWeightRegular,
      fontSize: fontSize.sm,
      borderRadius: '2rem',

      '&:hover, &:focus, &:active': {
        transform: 'none',
        opacity: '1 !important',
      },

      '&:hover': {
        backgroundColor: light.main,
      },

      '&.Mui-selected': {
        backgroundImage: `linear-gradient(90deg, ${gradients.info.state}, ${gradients.info.main})`,
        color: white.main,
        borderColor: info.state,
      },
    },
  },
};

export default paginationItem;
